import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  AGENDA_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import AgendaIndex from './AgendaIndex.vue';

const commonMeta = {
  permissions: [...ROLES, AGENDA_PERMISSIONS],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agenda'),
    component: AgendaIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'agenda_index',
        component: AgendaIndex,
        meta: commonMeta,
      },
    ],
  },
];
